import { Pipe, PipeTransform } from "@angular/core";
import { AssetHistoryDocumentStatus } from '@app/_models/enums/assetHistoryDocumentStatus';
import { Asset } from '@app/_models/_DTOs/asset';
import { AssetHistory } from '@app/_models/_DTOs/assetHistory';
import { AssetViewModel } from '@app/_models/_viewModels/asset.viewmodel';

@Pipe({
    name: 'sameBarCode',
    pure: false
})
export class SameBarCode implements PipeTransform {
    transform(value: AssetViewModel, conflictingAssetNames: string[]): any {
        if(conflictingAssetNames != undefined && conflictingAssetNames.length > 0 && value.barCode != undefined && value.barCode.length > 0){
            return true;
        }
        return false;
    }
}